import React, { createContext, ReactNode, useContext } from "react";
import { ManageCustomPermissionsLandingContextValue } from "./ManageCustomPermissionsLanding.types";

const ManageCustomPermissionsLandingContext =
  createContext<ManageCustomPermissionsLandingContextValue | null>(null);

interface ManageCustomPermissionsLandingProviderProps {
  value: ManageCustomPermissionsLandingContextValue;
  children: ReactNode;
}

export const ManageCustomPermissionsLandingProvider: React.FC<
  ManageCustomPermissionsLandingProviderProps
> = ({ value, children }) => {
  return (
    <ManageCustomPermissionsLandingContext.Provider value={value}>
      {children}
    </ManageCustomPermissionsLandingContext.Provider>
  );
};

export const useManageCustomPermissionsLanding = () => {
  const context = useContext(ManageCustomPermissionsLandingContext);

  if (!context) {
    throw new Error(
      "useManageCustomPermissionsLanding must be used inside ManageCustomPermissionsLandingProvider"
    );
  }

  return context as ManageCustomPermissionsLandingContextValue;
};
